import React from 'react';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import FacebookAppIcon from 'housecall-ui/dist/IconsAndImages/AppIcons/FacebookAppIcon';

const FacebookBookingStrategy = {
  previewInfo: {
    name: 'Facebook booking',
    iconSvg: <FacebookAppIcon size="xlarge" />,
    newTab: true,
  },
  headerInfo: {
    name: 'Facebook booking',
    category: 'Online booking',
    details:
      "75% of your customers are on Facebook - why not let them book you directly from your business page? Your Facebook booking link stays open even when your business is closed or you're busy, so customers can easily book in seconds at a time that's best for them.",
    iconSvg: <FacebookAppIcon size="xlarge" />,
  },
  media: {
    wistiaLink: 'https://fast.wistia.net/embed/iframe/y2vdmbqyvw?autoPlay=false',
  },
  sellingPoints: {
    headline: 'Why use Facebook Booking?',
    description:
      "Housecall Pro's Facebook Booking is integrated directly into your schedule, making it easier than ever to win more jobs and stay organized. Your customers can quickly view your real-time availability and self-book their own appointments, without playing phone tag.",
    orderedPoints: [],
  },
  price: {
    title: 'Housecall Pro Plan',
    price: 'No referral fee',
    description: (
      <Grid container spacing={8}>
        <Grid item xs={4}>
          <Typography align="left" variant="body1">
            Basic plan
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            Essentials plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            MAX plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
      </Grid>
    ),
  },
  supportContacts: [],
};

export default FacebookBookingStrategy;
